module.exports = __webpack_public_path__ + "img/symptom-a.a850e09a.png";